import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

interface StopSignInAsDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function StopSignInAsDialog({ open, onClose, onConfirm }: StopSignInAsDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="stop-sign-in-as-modal-title" maxWidth="sm" fullWidth>
      <DialogTitle id="stop-sign-in-as-modal-title">Are you sure you want to stop Sign In As?</DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          This will end your current impersonation session.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          No
        </Button>
        <Button
          onClick={() => {
            onClose();
            onConfirm();
          }}
          color="primary"
          variant="contained"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { StopSignInAsDialog };
